import { TFunction } from "i18next";
import * as yup from "yup1";
import { ERROR_MESSAGES } from "src/constants/errors";
import { FlowStepBaseSchema } from "../flow";

export const FlowStepTriggerFlowSchema = (t: TFunction) =>
  FlowStepBaseSchema(t).shape({
    next_flow: yup.string().required(t(ERROR_MESSAGES.REQUIRED)),
  });
